import { RadioList } from '@components/OnboardingRadioList'
import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.lg}rem;
`

export const ScrollContent = styled.div`
  flex: 1;
  overflow: auto;

  p {
    font-size: ${({ theme }) => theme.fontSize.md}rem;
    color: ${({ theme }) => theme.colors.metalGray};
    margin: 0 0 ${({ theme }) => theme.spacing.md}rem;
  }
`

export const Goal = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  font-size: ${({ theme }) => theme.fontSize.md}rem;

  & > * {
    margin: 0;
  }
`

export const GoalHeader = styled.h4``
export const GoalText = styled.p``
export const GoalButtons = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.xs}rem;
  flex-wrap: wrap;
`

export const StepSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.md}rem;
  padding-top: ${({ theme }) => theme.spacing.xs}rem;

  & > p {
    margin: 0;
  }
`

export const ChurnReasonRadioList = styled(RadioList)`
  > * {
    padding-inline: 0;
  }
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  padding-bottom: ${({ theme }) => theme.spacing.sm}rem;

  & > * {
    margin: 0;
  }
`

export const FooterActions = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  padding-top: ${({ theme }) => theme.spacing.xs}rem;
`

export const FooterSlot = styled.div<{ $alignRight?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $alignRight }) => ($alignRight ? 'flex-end' : 'flex-start')};
  min-width: 0;
`

export const FooterCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
`
